if (!customElements.get('faq-fmd')) {
  class FaqFmd extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('[data-faq-toggle]');
      this.init();
    }

    init() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.toggleItem.bind(this));
      });
    }

    toggleItem(event) {
      const button = event.currentTarget;
      const item = button.closest('.faq-fmd__item');
      const isOpen = item.classList.contains('is-open');

      item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', !isOpen);
    }
  }

  customElements.define('faq-fmd', FaqFmd);
}
